<qvs-page-header [title]="title">
  <ng-container end>
    <ion-buttons slot="end">
      <qvs-svg-icon
        *ngIf="showIcon; else showText"
        (click)="closed.emit()"
        class="qvs-page-header__toolbar__close"
        [src]="'assets/images/close.svg'"
      ></qvs-svg-icon>
      <ng-template #showText>
        <ion-button qvsClickKeydownEnterSpace (clickAndKeydown)="closed.emit()">
          {{ 'page-header.CANCEL' | translate }}
        </ion-button>
      </ng-template>
    </ion-buttons>
  </ng-container>
</qvs-page-header>
